import { CancelTokenSource } from "axios";
import { getExtension } from "../../utils";
import { startTransition } from "react";
import { createSlice } from "@reduxjs/toolkit";
import { DocumentPropertyType, DocumentUpdateArgs, defaultRequestBodyType, PresignedDocumentApiResponseType, defaultRequestBody, defaultSelectedDocument, defaultPresignedDocumentApiResponse, DocumentAuditType } from "../../constant/document";
import {
  fetchDocuments,
  fetchPaginateDocuments,
  fetchUploadMetaData,
  fetchTargetLanguageList,
  updateDocumentMetaData,
  fetchDocumentMetaData,
  setSelectedRecord,
  resetTabState,
  updateTab,
  updateRequestBody,
  fetchEditDocumentMetaData,
  getDocumentInfo,
  deleteDocument,
  updateUploadProgress,
  updateUploadCancelToken,
  documentUpload,
  fetchDocumentDetailsPresigned,
  saveEditDocument,
  startTranslation,
  resetSelectedDocument,
  getDocumentPresigned,
  openEditTranslationDocument,
  closeEditTranslationDocument,
  openDeleteTranslationDocument,
  closeDeleteTranslationDocument,
  openUploadTranslationDocument,
  openQuickUploadTranslationDocument,
  closeUploadTranslationDocument,
  closeQuickUploadTranslationDocument,
  openUploadFileProgress,
  closeUploadFileProgress,
  openDocumentInformation,
  closeDocumentInformation,
  openViewDocument,
  closeViewDocument,
  openDocumentInfoModal,
  closeDocumentInfoModal,
  auditLogModalOpen,
  auditLogModalClose,
  auditLogModalData,
  openLogoutModal,
  closeLogoutModal,
  statusChange,
  resetUpdateStatusState,
  fetchStatusDropdown,
  setSelectedDocumentIds,
  setAutoRefresh,
  autoRefresh,
  switchAutoFresh,
  fetchRefresh,
  storeDocumentInfo,
  stopAutoRefresh,
  fetchSearchTabs,
  setCustomFont,
  transferToQC,
  fetchViewDocumentDetailsPresigned,
  quickTextTranslation,
  fetchQuickTranslateLanguageList,
} from "./EngageTranslationAction";
import { InternalFailureException } from "@aws-sdk/client-lex-runtime-service";

export interface PaginationType {
  page: number;
  pageSize: number;
  hasMore: boolean;
  loading: boolean;
  view: string;
}
interface DocumentAPIStateType {
  loading: boolean;
  data: DocumentPropertyType[];
  error: string;
}

interface SelectedDocumentStateType {
  metaData: DocumentUpdateArgs;
  loading: boolean;
  selectedDocumentID: number;
  error: string;
}

interface NewTabStateType {
  editTranslationDocumentOpenSate: boolean;
  deleteTranslationDocumentOpenSate: boolean;
  data: DocumentPropertyType[];
  loading: boolean;
  error: string;
  currentRequestBody: defaultRequestBodyType;
  pagination: PaginationType;
  selectedDocument: SelectedDocumentStateType;
  selectedDocumentID: number;
  selectedDocumentName: string;
}

interface QualityControlStateType {
  documentInformationOpenState: boolean;
  data: DocumentPropertyType[];
  loading: boolean;
  error: string;
  modal: QualityControlDocumentInfoModal;
  currentRequestBody: defaultRequestBodyType;
  pagination: PaginationType;
  selectedDocument: SelectedDocumentStateType;
}

interface ClientReadyStateType {
  viewDocumentOpenState: boolean;
  data: DocumentPropertyType[];
  loading: boolean;
  error: string;
  currentRequestBody: defaultRequestBodyType;
  pagination: PaginationType;
  selectedDocument: SelectedDocumentStateType;
  fetchDocumentLoading: boolean;
  downLoadUrl: string;
  inputUrl: string;
  selectedDocumentIds: React.Key[];
}
interface ArchivedTabStateType {
  data: DocumentPropertyType[];
  loading: boolean;
  error: string;
  currentRequestBody: defaultRequestBodyType;
  pagination: PaginationType;
}
interface AllTabStateType {
  data: DocumentPropertyType[];
  loading: boolean;
  error: string;
  count: number;
  currentRequestBody: defaultRequestBodyType;
  pagination: PaginationType;
}

interface TabViewType {
  key: "new" | "quality-control" | "client-ready" | "archived" | "all";
  label: "New" | "Quality Control" | "Client Ready" | "Archived" | "All Items";
  count: number;
}

interface TabsArrayType {
  name: string;
  internalName: string;
  count: number;
  tabOrder: number;
}

interface TabViewType {
  key: "new" | "quality-control" | "client-ready" | "archived" | "all";
  label: "New" | "Quality Control" | "Client Ready" | "Archived" | "All Items";
  count: number;
}

export interface FileUpload {
  uploadProgress: number;
  cancelUploadToken: CancelTokenSource | null;
  status: "normal" | "exception" | "active" | "success";
  fileName: string;
  fileExtension: string;
  // file: File;
  error: string | null;
}

interface QualityControlDocumentInfoModal {
  modalStatus: boolean;
  modalData: any;
  modalLoading: boolean;
}

const initialFileUploadState: FileUpload = {
  uploadProgress: 0,
  cancelUploadToken: null,
  status: "normal",
  fileName: "",
  error: null,
  fileExtension: "",
};

interface FileUploadArrayObject {
  [key: string]: FileUpload;
  //generate isUploading callback to check if any file is still in progress by checking the status of each file in the object, give me that callback function in below line:
}
interface Client {
  id: number;
  label: string;
  value: number;
}
interface Language {
  id: number;
  label: string;
  value: number;
}
interface Status {
  id: number;
  label: string;
  value: number;
}
interface UploadFormMetaDataStateType {
  clientList: Client[];
  sourceLanguageList: Language[];
  targetLanguageList: Language[];
  loading: boolean;
  error: string;
}
interface quickTextTranslateDataStateType {
  sourceLanguageList: Language[];
  targetLanguageList: Language[];
  loading: boolean;
  error: string;
}
interface EngageTranslationMainStateType {
  documentAPIState: DocumentAPIStateType;
  pagination: PaginationType;
  currentRequestBody: defaultRequestBodyType;
  uploadFormMetaDataState: UploadFormMetaDataStateType;
  quickTextTranslateDataState: quickTextTranslateDataStateType;
  tabViews: TabViewType[];
  tabsArray: TabsArrayType[];
  uploadTranslationDocumentOpenSate: boolean;
  quickUploadTranslationDocumentOpenSate: boolean;
  uploadFileInProgressOpenState: boolean;
  tab: string;
  fileUploadArrayObject: FileUploadArrayObject;
  fileUploadCompleted: FileUpload;
  isUploading: boolean;
  uploadedID: number;
  fileUploadCount: number;
  logoutConfirmOpenState: boolean;
  tabsLoading: boolean;
  IsQcLoggedIn: boolean;
}

interface EngageTranslationDetailPageStateType {
  loading: boolean;
  error: string;
  loadingSave: boolean;
  documentDetail: PresignedDocumentApiResponseType;
  updateStatusState: {
    loading: boolean;
    errorMessage: string;
    error: boolean;
  };
  statusDropDown: Status[];
}

interface EngageTranslationViewDocumentPageType {
  loading: boolean;
  error: string;
  documentDetail: PresignedDocumentApiResponseType;
}

interface quickTranslationPageType {
  loading: boolean;
  error: any;
  data: { translatedText: string; inputText: string; status: boolean; message: [string] };
}

interface auditLogPageStateType {
  data: DocumentAuditType[];
  resultHeading: string;
  loading: boolean;
  error: string;
  modalStatus: boolean;
  modalData: any;
  pagination: PaginationType;
  currentRequestBody: any;
}

interface AutoRefreshStateType {
  autoRefresh: boolean;
  view: string;
  currentIntervalId: NodeJS.Timer | undefined;
  error: string;
  loading: boolean;
}

interface viewDocumentPageType {
  error: string;
  loading: boolean;
  success: boolean;
}

interface EngageTranslationStateType {
  engageTranslateMainState: EngageTranslationMainStateType;
  newTabState: NewTabStateType;
  autoRefreshState: AutoRefreshStateType;
  qualityControlState: QualityControlStateType;
  clientReadyState: ClientReadyStateType;
  archivedTabState: ArchivedTabStateType;
  allTabState: AllTabStateType;
  engageTranslationDetailPageState: EngageTranslationDetailPageStateType;
  engageTranslationViewDocumentPageState: EngageTranslationViewDocumentPageType;
  quickTranslationPage: quickTranslationPageType;
  auditLogPageState: auditLogPageStateType;
  viewDocumentPageState: viewDocumentPageType;
  customFonts: any;
}

const engageTranslationInitialState: EngageTranslationStateType = {
  customFonts: null,
  engageTranslateMainState: {
    tabsLoading: true,
    IsQcLoggedIn: false,
    documentAPIState: {
      loading: false,
      data: [],
      error: "",
    },
    pagination: {
      page: 2,
      pageSize: 30,
      hasMore: true,
      loading: false,
      view: "new",
    },
    uploadFormMetaDataState: {
      clientList: [],
      sourceLanguageList: [],
      targetLanguageList: [],
      loading: true,
      error: "",
    },
    quickTextTranslateDataState: {
      sourceLanguageList: [],
      targetLanguageList: [],
      loading: true,
      error: "",
    },
    tabViews: [],
    tabsArray: [],
    uploadTranslationDocumentOpenSate: false,
    quickUploadTranslationDocumentOpenSate: false,
    uploadFileInProgressOpenState: false,
    tab: "new",
    currentRequestBody: defaultRequestBody,
    fileUploadArrayObject: {},
    fileUploadCompleted: initialFileUploadState,
    isUploading: false,
    uploadedID: 0,
    fileUploadCount: 0,
    logoutConfirmOpenState: false,
  },
  autoRefreshState: {
    autoRefresh: true,
    error: "",
    currentIntervalId: undefined,
    loading: false,
    view: "new",
  },
  newTabState: {
    editTranslationDocumentOpenSate: false,
    deleteTranslationDocumentOpenSate: false,
    data: [],
    loading: false,

    error: "",
    currentRequestBody: defaultRequestBody,
    pagination: {
      page: 2,
      pageSize: 30,
      hasMore: true,
      loading: false,
      view: "new",
    },
    selectedDocument: defaultSelectedDocument,
    selectedDocumentID: 0,
    selectedDocumentName: "",
  },
  qualityControlState: {
    documentInformationOpenState: false,
    data: [],
    loading: false,
    error: "",
    currentRequestBody: defaultRequestBody,
    modal: {
      modalStatus: false,
      modalData: {},
      modalLoading: false,
    },
    pagination: {
      page: 2,
      pageSize: 30,
      hasMore: true,
      loading: false,
      view: "quality-control",
    },
    selectedDocument: defaultSelectedDocument,
  },
  clientReadyState: {
    viewDocumentOpenState: false,
    data: [],
    loading: false,
    error: "",
    currentRequestBody: defaultRequestBody,
    pagination: {
      page: 2,
      pageSize: 30,
      hasMore: true,
      loading: false,
      view: "client-ready",
    },
    selectedDocument: defaultSelectedDocument,
    fetchDocumentLoading: true,
    downLoadUrl: "",
    inputUrl: "",
    selectedDocumentIds: [],
  },
  archivedTabState: {
    data: [],
    loading: false,
    error: "",
    currentRequestBody: defaultRequestBody,
    pagination: {
      page: 2,
      pageSize: 30,
      hasMore: true,
      loading: false,
      view: "archived",
    },
  },
  allTabState: {
    data: [],
    loading: false,
    error: "",
    currentRequestBody: defaultRequestBody,
    count: 0,
    pagination: {
      page: 2,
      pageSize: 30,
      hasMore: true,
      loading: false,
      view: "all",
    },
  },
  engageTranslationDetailPageState: {
    loading: true,
    loadingSave: false,
    error: "",
    documentDetail: defaultPresignedDocumentApiResponse,
    updateStatusState: {
      loading: false,
      errorMessage: "",
      error: false,
    },
    statusDropDown: [],
  },

  engageTranslationViewDocumentPageState: {
    loading: false,
    error: "",
    documentDetail: defaultPresignedDocumentApiResponse,
  },

  quickTranslationPage: {
    loading: false,
    error: "",
    data: { translatedText: "", inputText: "", status: false, message: [""] },
  },

  auditLogPageState: {
    data: [],
    resultHeading: "",
    loading: true,
    error: "",
    modalStatus: false,
    modalData: {},
    currentRequestBody: {
      DocumentId: 0,
      pageNum: 1,
      pageSize: 15,
      sortColumn: "createdAt",
      isAsc: true,
    },
    pagination: {
      page: 2,
      pageSize: 15,
      hasMore: true,
      loading: false,
      view: "audit-log",
    },
  },

  viewDocumentPageState: {
    error: "",
    loading: false,
    success: false,
  },
};

const engageTranslationSlice = createSlice({
  initialState: engageTranslationInitialState,
  name: "engageTranslation",
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDocuments.pending, (state, action) => {
        state.engageTranslateMainState.documentAPIState.loading = true;
        switch (action.meta.arg.view) {
          case "new":
            state.newTabState.loading = true;
            break;
          case "quality-control":
            state.qualityControlState.loading = true;
            break;
          case "client-ready":
            state.clientReadyState.loading = true;
            break;
          case "archived":
            state.archivedTabState.loading = true;
            break;
          case "all":
            state.allTabState.loading = true;
            break;
          case "audit-log":
            state.auditLogPageState.loading = true;
            break;
        }
      })
      .addCase(fetchDocuments.fulfilled, (state, action) => {
        switch (action.meta.arg.view) {
          case "new":
            state.engageTranslateMainState.tabViews = action.payload.tabViews;
            state.newTabState.data = action.payload.results;
            state.newTabState.loading = false;
            break;
          case "quality-control":
            state.engageTranslateMainState.tabViews = action.payload.tabViews;
            state.qualityControlState.data = action.payload.results;
            state.qualityControlState.loading = false;
            break;
          case "client-ready":
            state.engageTranslateMainState.tabViews = action.payload.tabViews;
            state.clientReadyState.data = action.payload.results;
            state.clientReadyState.loading = false;
            break;
          case "archived":
            state.engageTranslateMainState.tabViews = action.payload.tabViews;
            state.archivedTabState.data = action.payload.results;
            state.archivedTabState.loading = false;
            break;
          case "all":
            state.engageTranslateMainState.tabViews = action.payload.tabViews;
            state.allTabState.data = action.payload.results;
            state.allTabState.count = action.payload.totalRecords;
            state.allTabState.loading = false;
            break;
          case "audit-log":
            state.auditLogPageState.data = action.payload.data;
            state.auditLogPageState.resultHeading = action.payload.searchHeading;
            state.auditLogPageState.loading = false;
            break;
        }
        state.engageTranslateMainState.documentAPIState.loading = false;
      })
      .addCase(fetchDocuments.rejected, (state, action) => {
        switch (action.meta.arg.view) {
          case "new":
            state.newTabState.loading = false;
            break;
          case "quality-control":
            state.qualityControlState.loading = false;
            break;
          case "client-ready":
            state.clientReadyState.loading = false;
            break;
          case "archived":
            state.archivedTabState.loading = false;
            break;
          case "all":
            state.allTabState.loading = false;
            break;
          case "audit-log":
            state.auditLogPageState.loading = false;
            break;
        }
        state.engageTranslateMainState.documentAPIState.loading = false;

        state.engageTranslateMainState.documentAPIState.error = action.error.message ?? "Failed to fetch documents";
      })

      .addCase(fetchPaginateDocuments.pending, (state, action) => {
        switch (action.meta.arg.view) {
          case "new":
            state.newTabState.pagination.loading = true;
            break;
          case "quality-control":
            state.qualityControlState.pagination.loading = true;
            break;
          case "client-ready":
            state.clientReadyState.pagination.loading = true;
            break;
          case "archived":
            state.archivedTabState.pagination.loading = true;
            break;
          case "all":
            state.allTabState.pagination.loading = true;
            break;
          case "audit-log":
            state.auditLogPageState.pagination.loading = true;
            break;
        }
      })
      .addCase(fetchPaginateDocuments.fulfilled, (state, action) => {
        switch (action.meta.arg.view) {
          case "new":
            state.newTabState.data = [...state.newTabState.data, ...action.payload.data];
            state.newTabState.pagination.loading = false;
            state.newTabState.pagination.page = state.newTabState.pagination.page + 1;
            state.newTabState.pagination.hasMore = action.payload.hasMore;
            break;
          case "quality-control":
            state.qualityControlState.data = [...state.qualityControlState.data, ...action.payload.data];
            state.qualityControlState.pagination.loading = false;
            state.qualityControlState.pagination.page = state.qualityControlState.pagination.page + 1;
            state.qualityControlState.pagination.hasMore = action.payload.hasMore;

            break;
          case "client-ready":
            state.clientReadyState.data = [...state.clientReadyState.data, ...action.payload.data];
            state.clientReadyState.pagination.loading = false;
            state.clientReadyState.pagination.page = state.clientReadyState.pagination.page + 1;
            state.clientReadyState.pagination.hasMore = action.payload.hasMore;
            break;
          case "audit-log":
            state.auditLogPageState.data = [...state.auditLogPageState.data, ...action.payload.data];
            state.auditLogPageState.pagination.loading = false;
            state.auditLogPageState.pagination.page = state.auditLogPageState.pagination.page + 1;
            state.auditLogPageState.pagination.hasMore = action.payload.hasMore;
            break;
          case "archived":
            state.archivedTabState.data = [...state.archivedTabState.data, ...action.payload.data];
            state.archivedTabState.pagination.loading = false;
            state.archivedTabState.pagination.page = state.archivedTabState.pagination.page + 1;
            state.archivedTabState.pagination.hasMore = action.payload.hasMore;
            break;
          case "all":
            state.allTabState.data = [...state.allTabState.data, ...action.payload.data];
            state.allTabState.pagination.loading = false;
            state.allTabState.pagination.page = state.allTabState.pagination.page + 1;
            state.allTabState.pagination.hasMore = action.payload.hasMore;
            break;
        }
      })
      .addCase(fetchPaginateDocuments.rejected, (state, action) => {
        switch (action.meta.arg.view) {
          case "new":
            state.newTabState.pagination.loading = false;
            break;
          case "quality-control":
            state.qualityControlState.pagination.loading = false;
            break;
          case "client-ready":
            state.clientReadyState.pagination.loading = false;
            break;
          case "archived":
            state.archivedTabState.pagination.loading = false;
            break;
          case "all":
            state.allTabState.pagination.loading = false;
            break;
          case "audit-log":
            state.auditLogPageState.pagination.loading = false;
            break;
        }
        state.engageTranslateMainState.documentAPIState.error = action.error.message ?? "Failed to fetch documents";
      })

      //For fetching upload meta data
      .addCase(fetchUploadMetaData.pending, (state, action) => {
        state.engageTranslateMainState.uploadFormMetaDataState.loading = true;
      })
      .addCase(fetchUploadMetaData.fulfilled, (state, action) => {
        state.engageTranslateMainState.uploadFormMetaDataState.loading = false;
        state.engageTranslateMainState.uploadFormMetaDataState.clientList = action.payload.clientList;
        state.engageTranslateMainState.uploadFormMetaDataState.sourceLanguageList = action.payload.sourceLanguageList;
      })
      .addCase(fetchUploadMetaData.rejected, (state, action) => {
        state.engageTranslateMainState.uploadFormMetaDataState.loading = false;
        state.engageTranslateMainState.documentAPIState.error = action.error.message ?? "Failed to fetch documents";
      })

      // For quick translate
      .addCase(fetchQuickTranslateLanguageList.pending, (state, action) => {
        state.engageTranslateMainState.quickTextTranslateDataState.loading = true;
      })
      .addCase(fetchQuickTranslateLanguageList.fulfilled, (state, action) => {
        state.engageTranslateMainState.quickTextTranslateDataState.loading = false;
        state.engageTranslateMainState.quickTextTranslateDataState.sourceLanguageList = action.payload.sourceLanguageList;
      })
      .addCase(fetchQuickTranslateLanguageList.rejected, (state, action) => {
        state.engageTranslateMainState.quickTextTranslateDataState.loading = false;
        state.engageTranslateMainState.documentAPIState.error = action.error.message ?? "Failed to fetch documents";
      })

      .addCase(quickTextTranslation.pending, (state, action) => {
        state.quickTranslationPage.loading = true;
      })
      .addCase(quickTextTranslation.fulfilled, (state, action) => {
        state.quickTranslationPage.data = action.payload.data;
        let messageToUse: any = state.quickTranslationPage.data.message;
        if (state.quickTranslationPage.data.message.length > 0) {
          messageToUse = state.quickTranslationPage.data.message[0].split(`"`)[3];
        }
        state.quickTranslationPage.error = messageToUse;
        state.quickTranslationPage.loading = false;
      })
      .addCase(quickTextTranslation.rejected, (state, action) => {
        state.quickTranslationPage.loading = false;
        state.quickTranslationPage.error = action.error.message;
      })

      .addCase(transferToQC.pending, (state) => {
        state.viewDocumentPageState.loading = true;
      })
      .addCase(transferToQC.fulfilled, (state) => {
        state.viewDocumentPageState.loading = false;
        state.viewDocumentPageState.success = true;
      })
      .addCase(transferToQC.rejected, (state) => {
        state.viewDocumentPageState.loading = false;
        state.viewDocumentPageState.error = "Failed to transfer to QC";
      })

      //Fetch target language list
      .addCase(fetchTargetLanguageList.pending, (state, action) => {
        state.engageTranslateMainState.uploadFormMetaDataState.loading = true;
        state.engageTranslateMainState.quickTextTranslateDataState.loading = true;
      })
      .addCase(fetchTargetLanguageList.fulfilled, (state, action) => {
        state.engageTranslateMainState.quickTextTranslateDataState.loading = false;
        state.engageTranslateMainState.quickTextTranslateDataState.targetLanguageList = action.payload.targetLanguageList;
        state.engageTranslateMainState.uploadFormMetaDataState.loading = false;
        state.engageTranslateMainState.uploadFormMetaDataState.targetLanguageList = action.payload.targetLanguageList;
      })
      .addCase(fetchTargetLanguageList.rejected, (state, action) => {
        state.engageTranslateMainState.quickTextTranslateDataState.loading = false;
        state.engageTranslateMainState.quickTextTranslateDataState.error = action.error.message ?? "Failed to fetch documents";
        state.engageTranslateMainState.uploadFormMetaDataState.loading = false;
        state.engageTranslateMainState.uploadFormMetaDataState.error = action.error.message ?? "Failed to fetch documents";
      })

      //For update document meta data
      .addCase(updateDocumentMetaData.pending, (state, action) => {
        state.newTabState.loading = true;
      })
      .addCase(updateDocumentMetaData.fulfilled, (state, action) => {
        state.newTabState.loading = false;
      })
      .addCase(updateDocumentMetaData.rejected, (state, action) => {
        state.newTabState.loading = false;
        state.newTabState.error = action.error.message ?? "Failed to update document";
      })

      // For fetching document meta data

      .addCase(fetchDocumentMetaData.pending, (state, action) => {
        state.qualityControlState.selectedDocument.loading = true;
      })
      .addCase(fetchDocumentMetaData.fulfilled, (state, action) => {
        state.qualityControlState.selectedDocument.loading = false;
        state.qualityControlState.selectedDocument.metaData = action.payload;
      })
      .addCase(fetchDocumentMetaData.rejected, (state, action) => {
        state.qualityControlState.selectedDocument.loading = false;
        state.qualityControlState.selectedDocument.error = action.error.message ?? "Failed to fetch document";
      })

      // For getting the information from selected record to each modal
      .addCase(setSelectedRecord, (state, action) => {
        switch (action.payload.view) {
          case "new":
            state.newTabState.selectedDocument.selectedDocumentID = action.payload.selectedRecordID;
            break;
          case "quality-control":
            state.qualityControlState.selectedDocument.selectedDocumentID = action.payload.selectedRecordID;
            break;
          case "client-ready":
            state.clientReadyState.selectedDocument.selectedDocumentID = action.payload.selectedRecordID;
            break;
        }
      })

      //For reset tab state in each view when user move from on tab to another
      .addCase(resetTabState, (state, action) => {
        switch (action.payload) {
          case "new":
            state.newTabState = {
              ...engageTranslationInitialState.newTabState,
              data: state.newTabState.data,
            };
            break;
          case "quality-control":
            state.qualityControlState = {
              ...engageTranslationInitialState.qualityControlState,
              data: state.qualityControlState.data,
            };
            break;
          case "client-ready":
            state.clientReadyState = {
              ...engageTranslationInitialState.clientReadyState,
              data: state.clientReadyState.data,
            };
            break;
          case "archived":
            state.archivedTabState = {
              ...engageTranslationInitialState.archivedTabState,
              data: state.archivedTabState.data,
            };
            break;
          case "all":
            state.allTabState = {
              ...engageTranslationInitialState.allTabState,
              data: state.allTabState.data,
            };
            break;
          case "audit-log":
            state.auditLogPageState = engageTranslationInitialState.auditLogPageState;
            break;
        }
      })

      //For tab update
      .addCase(updateTab, (state, action) => {
        state.engageTranslateMainState.tab = action.payload;
      })

      //Upload request body for sort and filter
      .addCase(updateRequestBody, (state, action) => {
        switch (action.payload.view) {
          case "new":
            state.newTabState.currentRequestBody = action.payload.requestBody;
            break;
          case "quality-control":
            state.qualityControlState.currentRequestBody = action.payload.requestBody;
            break;
          case "client-ready":
            state.clientReadyState.currentRequestBody = action.payload.requestBody;
            break;
          case "archived":
            state.archivedTabState.currentRequestBody = action.payload.requestBody;
            break;
          case "all":
            state.allTabState.currentRequestBody = action.payload.requestBody;
            break;
          case "audit-log":
            state.auditLogPageState.currentRequestBody = action.payload.requestBody;
            break;
        }
      })

      //For edit document meta data
      .addCase(fetchEditDocumentMetaData.pending, (state, action) => {
        state.newTabState.selectedDocument.loading = true;
      })
      .addCase(fetchEditDocumentMetaData.fulfilled, (state, action) => {
        state.engageTranslateMainState.uploadFormMetaDataState.clientList = action.payload.clientList;
        state.engageTranslateMainState.uploadFormMetaDataState.sourceLanguageList = action.payload.sourceLanguageList;
        state.engageTranslateMainState.uploadFormMetaDataState.targetLanguageList = action.payload.targetLanguageList;
        state.newTabState.selectedDocument.metaData = action.payload.fetchEditDocumentMetaData;
        state.newTabState.selectedDocument.loading = false;
      })
      .addCase(fetchEditDocumentMetaData.rejected, (state, action) => {
        state.newTabState.selectedDocument.loading = false;
        state.newTabState.selectedDocument.error = action.error.message ?? "Failed to fetch document";
      })

      .addCase(getDocumentInfo.pending, (state) => {
        state.qualityControlState.modal.modalLoading = true;
      })
      .addCase(getDocumentInfo.fulfilled, (state, action) => {
        state.qualityControlState.modal.modalData = action.payload;
        state.qualityControlState.modal.modalLoading = false;
      })
      .addCase(getDocumentInfo.rejected, (state) => {
        state.qualityControlState.modal.modalLoading = false;
      })

      //For delete document
      .addCase(deleteDocument.pending, (state, action) => {
        state.newTabState.loading = true;
      })
      .addCase(deleteDocument.fulfilled, (state, action) => {
        state.newTabState.loading = false;
      })
      .addCase(deleteDocument.rejected, (state, action) => {
        state.newTabState.loading = false;
        state.newTabState.error = action.error.message ?? "Failed to delete document";
        state.newTabState.error = action.error.message ?? "Failed to delete document";
      })

      //For fetching tabs
      .addCase(fetchSearchTabs.pending, (state, action) => {
        state.engageTranslateMainState.tabsLoading = true;
      })
      .addCase(fetchSearchTabs.fulfilled, (state, action) => {
        state.engageTranslateMainState.tabsArray = action.payload;
        console.log(action.payload);

        if (action.payload[0].internalName === "quality-control") {
          state.engageTranslateMainState.IsQcLoggedIn = true;
        } else {
          state.engageTranslateMainState.IsQcLoggedIn = false;
        }
        state.engageTranslateMainState.tabsLoading = false;
      })
      .addCase(fetchSearchTabs.rejected, (state, action) => {
        state.engageTranslateMainState.tabsLoading = false;
      })

      //For upload feature
      .addCase(updateUploadProgress, (state, action) => {
        state.engageTranslateMainState.fileUploadArrayObject[action.payload.fileName] = {
          ...state.engageTranslateMainState.fileUploadArrayObject[action.payload.fileName],
          uploadProgress: action.payload.progress,
        };
        state.engageTranslateMainState.fileUploadArrayObject[action.payload.fileName] = {
          ...state.engageTranslateMainState.fileUploadArrayObject[action.payload.fileName],
          uploadProgress: action.payload.progress,
        };
      })
      .addCase(updateUploadCancelToken, (state, action) => {
        state.engageTranslateMainState.fileUploadArrayObject[action.payload.fileName] = {
          ...state.engageTranslateMainState.fileUploadArrayObject[action.payload.fileName],
          cancelUploadToken: action.payload.cancelToken,
        };
        state.engageTranslateMainState.fileUploadArrayObject[action.payload.fileName] = {
          ...state.engageTranslateMainState.fileUploadArrayObject[action.payload.fileName],
          cancelUploadToken: action.payload.cancelToken,
        };
      })
      .addCase(documentUpload.pending, (state, action) => {
        state.engageTranslateMainState.isUploading = true;
        state.engageTranslateMainState.fileUploadCount = state.engageTranslateMainState.fileUploadCount + 1;
        state.engageTranslateMainState.fileUploadArrayObject[action.meta.arg.file.name] = {
          ...initialFileUploadState,
          fileName: action.meta.arg.file.name,
          fileExtension: getExtension(action.meta.arg.file.type),
          status: "active",
        };
      })
      .addCase(documentUpload.fulfilled, (state, action) => {
        state.engageTranslateMainState.fileUploadArrayObject[action.meta.arg.file.name] = {
          ...state.engageTranslateMainState.fileUploadArrayObject[action.meta.arg.file.name],
          status: "success",
        };
        state.engageTranslateMainState.fileUploadCompleted = {
          ...state.engageTranslateMainState.fileUploadArrayObject[action.meta.arg.file.name],
        };
        state.engageTranslateMainState.uploadedID = action.payload.id;
        state.engageTranslateMainState.isUploading = Object.values(state.engageTranslateMainState.fileUploadArrayObject).some((fileUpload) => fileUpload.status === "active");
        state.engageTranslateMainState.fileUploadCount = state.engageTranslateMainState.fileUploadCount - 1;
      })
      .addCase(documentUpload.rejected, (state, action) => {
        state.engageTranslateMainState.fileUploadArrayObject[action.meta.arg.file.name] = {
          ...state.engageTranslateMainState.fileUploadArrayObject[action.meta.arg.file.name],
          status: "exception",
        };
        state.engageTranslateMainState.fileUploadCompleted = {
          ...state.engageTranslateMainState.fileUploadArrayObject[action.meta.arg.file.name],
        };
        state.engageTranslateMainState.isUploading = Object.values(state.engageTranslateMainState.fileUploadArrayObject).some((fileUpload) => fileUpload.status === "active");
        state.engageTranslateMainState.fileUploadCount = state.engageTranslateMainState.fileUploadCount - 1;
      })

      // For view page
      .addCase(fetchViewDocumentDetailsPresigned.pending, (state) => {
        state.engageTranslationViewDocumentPageState.loading = true;
      })
      .addCase(fetchViewDocumentDetailsPresigned.fulfilled, (state, action) => {
        state.engageTranslationViewDocumentPageState.loading = false;
        console.log("in");
        state.engageTranslationViewDocumentPageState.documentDetail = action.payload;
      })
      .addCase(fetchViewDocumentDetailsPresigned.rejected, (state, action) => {
        state.engageTranslationViewDocumentPageState.loading = false;
        state.engageTranslationViewDocumentPageState.error = action.error.message ?? "Failed to fetch document";
      })

      // For QC/edit page
      .addCase(fetchDocumentDetailsPresigned.pending, (state, action) => {
        state.engageTranslationDetailPageState.loading = true;
      })
      .addCase(fetchDocumentDetailsPresigned.fulfilled, (state, action) => {
        state.engageTranslationDetailPageState.loading = false;
        state.engageTranslationDetailPageState.documentDetail = action.payload.documentDetail;
        state.engageTranslationDetailPageState.statusDropDown = action.payload.statusDropdown;
      })
      .addCase(fetchDocumentDetailsPresigned.rejected, (state, action) => {
        state.engageTranslationDetailPageState.loading = false;
        state.engageTranslationDetailPageState.error = action.error.message ?? "Failed to fetch document";
      })

      .addCase(saveEditDocument.pending, (state, action) => {
        state.engageTranslationDetailPageState.loadingSave = true;
      })
      .addCase(saveEditDocument.fulfilled, (state, action) => {
        state.engageTranslationDetailPageState.loadingSave = false;
      })
      .addCase(saveEditDocument.rejected, (state, action) => {
        state.engageTranslationDetailPageState.loadingSave = false;
        state.engageTranslationDetailPageState.error = action.error.message ?? "Failed to save document";
      })

      .addCase(startTranslation.pending, (state, action) => {
        state.newTabState.loading = true;
      })
      .addCase(startTranslation.fulfilled, (state, action) => {
        state.newTabState.loading = false;
      })
      .addCase(startTranslation.rejected, (state, action) => {
        state.newTabState.loading = false;
        state.newTabState.error = action.error.message ?? "Failed to start translation";
      })

      .addCase(resetSelectedDocument, (state, action) => {
        switch (action.payload.view) {
          case "new":
            state.newTabState.selectedDocument = defaultSelectedDocument;
            break;
          case "quality-control":
            state.qualityControlState.selectedDocument = defaultSelectedDocument;
            break;
          case "client-ready":
            state.clientReadyState.selectedDocument = defaultSelectedDocument;
            break;
        }
      })

      .addCase(setSelectedDocumentIds, (state, action) => {
        state.clientReadyState.selectedDocumentIds = action.payload.selectedDocumentIds;
      })

      .addCase(getDocumentPresigned.pending, (state, action) => {
        state.clientReadyState.loading = true;
        state.clientReadyState.fetchDocumentLoading = true;
      })
      .addCase(getDocumentPresigned.fulfilled, (state, action) => {
        state.clientReadyState.loading = false;
        state.clientReadyState.downLoadUrl = action.payload.targetDocPresignedUrl;
        state.clientReadyState.inputUrl = action.payload.sourceDocPresignedUrl;
        state.clientReadyState.fetchDocumentLoading = false;
      })
      .addCase(getDocumentPresigned.rejected, (state, action) => {
        state.clientReadyState.loading = false;
        state.clientReadyState.error = action.error.message ?? "Failed to fetch document";
        state.clientReadyState.fetchDocumentLoading = false;
      })

      .addCase(statusChange.pending, (state, action) => {
        state.engageTranslationDetailPageState.updateStatusState.loading = true;
      })
      .addCase(statusChange.fulfilled, (state, action) => {
        state.engageTranslationDetailPageState.updateStatusState.loading = false;
      })
      .addCase(statusChange.rejected, (state, action) => {
        state.engageTranslationDetailPageState.updateStatusState.loading = false;
        state.engageTranslationDetailPageState.updateStatusState.error = true;
        state.engageTranslationDetailPageState.updateStatusState.errorMessage = action.error.message ?? "Failed to update status";
      })

      .addCase(resetUpdateStatusState, (state, action) => {
        state.engageTranslationDetailPageState.updateStatusState = engageTranslationInitialState.engageTranslationDetailPageState.updateStatusState;
      })
      // .addCase(autoRefresh.pending, (state, action) => {
      //   state.autoRefreshState.loading = true;
      // })
      // .addCase(autoRefresh.fulfilled, (state, action) => {
      //   state.autoRefreshState.loading = false;
      // })
      // .addCase(autoRefresh.rejected, (state, action) => {
      //   state.autoRefreshState.loading = false;
      //   state.autoRefreshState.error = action.error.message ?? "Failed to fetch auto refresh";
      // })

      .addCase(fetchRefresh.pending, (state, action) => {
        state.autoRefreshState.loading = true;
      })
      .addCase(fetchRefresh.fulfilled, (state, action) => {
        switch (action.meta.arg.view) {
          case "new":
            state.engageTranslateMainState.tabViews = action.payload.tabViews;
            state.newTabState.data = action.payload.results;
            break;
          case "quality-control":
            state.engageTranslateMainState.tabViews = action.payload.tabViews;
            state.qualityControlState.data = action.payload.results;
            break;
          case "client-ready":
            state.engageTranslateMainState.tabViews = action.payload.tabViews;
            state.clientReadyState.data = action.payload.results;
            break;
          case "archived":
            state.engageTranslateMainState.tabViews = action.payload.tabViews;
            state.archivedTabState.data = action.payload.results;
            break;
          case "all":
            state.engageTranslateMainState.tabViews = action.payload.tabViews;
            state.allTabState.data = action.payload.results;
            break;
          case "audit-log":
            state.auditLogPageState.data = action.payload.data;
            state.auditLogPageState.resultHeading = action.payload.searchHeading;
            break;
        }
        state.autoRefreshState.loading = false;
      })
      .addCase(fetchRefresh.rejected, (state, action) => {
        state.autoRefreshState.loading = false;
        state.autoRefreshState.error = action.error.message ?? "Failed to fetch auto refresh";
      })

      .addCase(setAutoRefresh, (state, action) => {
        state.autoRefreshState.view = action.payload.view;
        state.autoRefreshState.currentIntervalId = action.payload.intervalId;
      })
      .addCase(switchAutoFresh, (state, action) => {
        state.autoRefreshState.autoRefresh = action.payload.autoRefresh;
      })
      .addCase(stopAutoRefresh, (state, action) => {
        clearInterval(state.autoRefreshState.currentIntervalId);
      })
      .addCase(openEditTranslationDocument, (state) => {
        state.newTabState.editTranslationDocumentOpenSate = true;
      })
      .addCase(closeEditTranslationDocument, (state) => {
        state.newTabState.editTranslationDocumentOpenSate = false;
      })
      .addCase(openDeleteTranslationDocument, (state) => {
        state.newTabState.deleteTranslationDocumentOpenSate = true;
      })
      .addCase(closeDeleteTranslationDocument, (state) => {
        state.newTabState.deleteTranslationDocumentOpenSate = false;
      })
      .addCase(openUploadTranslationDocument, (state) => {
        state.engageTranslateMainState.uploadTranslationDocumentOpenSate = true;
      })
      .addCase(openQuickUploadTranslationDocument, (state) => {
        state.engageTranslateMainState.quickUploadTranslationDocumentOpenSate = true;
      })
      .addCase(closeUploadTranslationDocument, (state) => {
        state.engageTranslateMainState.uploadTranslationDocumentOpenSate = false;
      })
      .addCase(closeQuickUploadTranslationDocument, (state) => {
        state.engageTranslateMainState.quickUploadTranslationDocumentOpenSate = false;
      })
      .addCase(openUploadFileProgress, (state) => {
        state.engageTranslateMainState.uploadFileInProgressOpenState = true;
      })
      .addCase(closeUploadFileProgress, (state) => {
        state.engageTranslateMainState.uploadFileInProgressOpenState = false;
      })
      .addCase(openDocumentInformation, (state) => {
        state.qualityControlState.documentInformationOpenState = true;
      })
      .addCase(closeDocumentInformation, (state) => {
        state.qualityControlState.documentInformationOpenState = false;
      })
      .addCase(openViewDocument, (state) => {
        state.clientReadyState.viewDocumentOpenState = true;
      })
      .addCase(closeViewDocument, (state) => {
        state.clientReadyState.viewDocumentOpenState = false;
      })
      .addCase(openDocumentInfoModal, (state) => {
        state.qualityControlState.modal.modalStatus = true;
      })
      .addCase(closeDocumentInfoModal, (state) => {
        state.qualityControlState.modal.modalStatus = false;
      })
      .addCase(auditLogModalOpen, (state) => {
        state.auditLogPageState.modalStatus = true;
      })
      .addCase(auditLogModalClose, (state) => {
        state.auditLogPageState.modalStatus = false;
      })
      .addCase(auditLogModalData, (state, action) => {
        state.auditLogPageState.modalData = action.payload.data;
      })
      .addCase(openLogoutModal, (state) => {
        state.engageTranslateMainState.logoutConfirmOpenState = true;
      })
      .addCase(closeLogoutModal, (state) => {
        state.engageTranslateMainState.logoutConfirmOpenState = false;
      })
      .addCase(storeDocumentInfo, (state, action) => {
        state.newTabState.selectedDocumentName = action.payload.selectedRecordName;
        state.newTabState.selectedDocumentID = action.payload.selectedRecordID;
      })
      .addCase(setCustomFont, (state, action) => {
        state.customFonts = action.payload;
      });
    // .addCase(getDocumentAuditLog.pending, (state, action) => {
    //   state.auditLogPageState.loading = true;
    // })
    // .addCase(getDocumentAuditLog.fulfilled, (state, action) => {
    //   state.auditLogPageState.data = action.payload.data;
    //   state.auditLogPageState.loading = false;
    // })
    // .addCase(getDocumentAuditLog.rejected, (state, action) => {
    //   state.auditLogPageState.loading = false;
    //   state.auditLogPageState.error = "Failed to fetch logs";
    // });
  },
});
export default engageTranslationSlice.reducer;
